import React from 'react'
import Build from './Build'
import Empower from './Empower'
import Hero from './Hero'
import Logo from './Logo'
import Next from "./Next"
import Remote from './Remote'
import Brighter from "./Brighter"
import Welcome from './Welcome'
import Anytime from './Anytime'
import Scale from './Scale'
import Footer from './Footer'
import Hold from "./Hold"

const Homescreen = () => {
  return (
    <div>
        <Hero />
        <Next />
        <Logo />
        <Build />
        <Empower />
        <Remote />
        <Brighter />
        <Welcome />
        <Hold />
        <Scale />
        <Footer />
    </div>
  )
}

export default Homescreen